import { cacheKeys } from "config";
import { useQuery } from "react-query";
import { publicationsClient } from "../client/publicationsClient";

export const useAppsData = () => {
  const { data: { data: appsData } = {}, isLoading } = useQuery(
    [cacheKeys.publications.getApps],
    publicationsClient.getApps
  );

  return {
    apps: appsData?.results || [],
    isLoading,
  };
};
